/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https:/abs.twimg.com/en/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

/**
 * @fileoverview The entry point for JsAction.  This is mean to be inlined in
 * the main HTML page.
 *
 * It will automatically read a list of event types from an element containing
 * the data-jsaction-events attribute and create a container for it. This
 * element must be present in the DOM for event binding to succeed.
 */

'use strict';

var base = __webpack_require__(2);
var eventcontract = __webpack_require__(192);

/**
 * Binds all events for a given JsAction container.
 * @param {!eventcontract.EventContract} contract
 * @param {Element} container
 * @return {boolean} True, if events were successfully bound.
 */
function bindEventsForContainer(contract, container) {
  if (container === null) {
    return false;
  }
  var eventTypes = container.getAttribute('data-jsaction-events');
  if (!eventTypes) {
    return false;
  }
  contract.addContainer(container);

  eventTypes = eventTypes.split(',');

  /*jshint -W084 */
  /* Allow assignment in the for-loop */
  for (var i = 0, eventType; eventType = eventTypes[i++];) {
    contract.addEvent(eventType);
  }
  /*jshint +W084 */

  return true;
}

/**
 * Creates an event contract.
 * @param {!Object} global
 */

function main(global) {
  var contract = new eventcontract.EventContract();
  var container = document.querySelector('[data-jsaction-events]');
  if (bindEventsForContainer(contract, container)) {
    // jscs:disable requireDotNotation
    global['jsaction'] = {};
    global['jsaction']['__eventContract'] = contract;
    global['jsaction']['__dispatchTo'] = function (dispatcher) {
      contract.dispatchTo(dispatcher);
    };
    // jscs:enable requireDotNotation
  }
}

// Bootstraps an event contract.
main(base.global);


/***/ },

/***/ 2:
/***/ function(module, exports, __webpack_require__) {

// Copyright 2013 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

'use strict';

/* Name for unique ID property. */
var UID_PROPERTY = 'activator_uid_' +
  Math.floor(Math.random() * 2147483648).toString(36);

var UidCounter = 0;

function getGlobal() {
  return window || this;
}

function getUid(obj) {
  return obj[UID_PROPERTY] || (obj[UID_PROPERTY] = ++UidCounter);
}
exports.getUid = getUid;

function isArrayLike(val) {
  return val && ((typeof val) == 'object' && typeof val.length == 'number');
}
exports.isArrayLike = isArrayLike;

exports.isArray = Array.isArray;

exports.global = /** {*} */ getGlobal();

// jscs: disable
// jshint ignore: start
exports.inherits = function(childCtor, parentCtor) {
  /** @constructor */
  function tempCtor() {};
  tempCtor.prototype = parentCtor.prototype;
  childCtor.superClass_ = parentCtor.prototype;
  childCtor.prototype = new tempCtor();
  /** @override */
  childCtor.prototype.constructor = childCtor;

  /**
   * Calls superclass constructor/method.
   *
   * This function is only available if you use goog.inherits to
   * express inheritance relationships between classes.
   *
   * NOTE: This is a replacement for goog.base and for superClass_
   * property defined in childCtor.
   *
   * @param {!Object} me Should always be "this".
   * @param {string} methodName The method name to call. Calling
   *     superclass constructor can be done with the special string
   *     'constructor'.
   * @param {...*} var_args The arguments to pass to superclass
   *     method/constructor.
   * @return {*} The return value of the superclass method/constructor.
   */
  childCtor.base = function(me, methodName, var_args) {
    // Copying using loop to avoid deop due to passing arguments object to
    // function. This is faster in many JS engines as of late 2014.
    var args = new Array(arguments.length - 2);
    for (var i = 2; i < arguments.length; i++) {
      args[i - 2] = arguments[i];
    }
    return parentCtor.prototype[methodName].apply(me, args);
  };
};
// jscs: enable
// jshint ignore: end


/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

// Copyright 2011 Google Inc. All rights reserved.

/**
 *
 * @fileoverview Defines and documents the various lexical components
 * that make up the different aspects of the jsaction syntax.
 *
 * NOTE(user): Yep, the things defined here are lexical, but their
 * grouping and documentation is what defines the jsaction syntax.
 */

/**
 * All attributes used by jsaction.
 * @enum {string}
 */
exports.Attribute = {
  /**
   * The jsaction attribute defines a mapping of a DOM event to a
   * generic event (aka jsaction), to which the actual event handlers
   * that implement the behavior of the application are bound. The
   * value is a semicolon separated list of colon separated pairs of
   * an optional DOM event name and a jsaction name. If the optional
   * DOM event name is omitted, 'click' is assumed. The jsaction names
   * are dot separated pairs of a namespace and a simple jsaction
   * name. If the namespace is absent, it is taken from the closest
   * ancestor element with a jsnamespace attribute, if there is
   * any. If there is no ancestor with a jsnamespace attribute, the
   * simple name is assumed to be the jsaction name.
   *
   * Used by EventContract.
   */
  JSACTION: 'jsaction',

  /**
   * The jsnamespace attribute provides the namespace part of the
   * jaction names occurring in the jsaction attribute where it's
   * missing.
   *
   * Used by EventContract.
   */
  JSNAMESPACE: 'jsnamespace',

  /**
   * The oi attribute is a log impression tag for impression logging
   * and action tracking. For an element that carries a jsaction
   * attribute, the element is identified for the purpose of
   * impression logging and click tracking by the dot separated path
   * of all oi attributes in the chain of ancestors of the element.
   *
   * Used by ActionFlow.
   */
  OI: 'oi',

  /**
   * The ved attribute is an encoded ClickTrackingCGI proto to track
   * visual elements.
   *
   * Used by ActionFlow.
   */
  VED: 'ved',

  /**
   * The vet attribute is the visual element type used to identify tracked
   * visual elements.
   */
  VET: 'vet',

  /**
   * Support for iteration on reprocessing.
   *
   * Used by ActionFlow.
   */
  JSINSTANCE: 'jsinstance',

  /**
   * All click jsactions that happen on the element that carries this
   * attribute or its descendants are automatically logged.
   * Impressions of jsactions on these elements are tracked too, if
   * requested by the impression() method of ActionFlow.
   *
   * Used by ActionFlow.
   */
  JSTRACK: 'jstrack',

  /**
   * The attribute jstrackrate defines a custom sampling rate for
   * jsactions that are tracked by jstrack.
   *
   * Used by ActionFlow.
   */
  JSTRACKRATE: 'jstrackrate'
};

/**
 * Special ActionFlow branch names defined by jsaction.
 * @enum {string}
 */
exports.Branch = {
  /**
   * The main branch, i.e. the branch the action flow instance starts
   * right at construction.
   */
  MAIN: 'main-actionflow-branch'
};

/**
 * All special characters used by jsaction.
 * @enum {string}
 */
exports.Char = {
  /**
   * The separator between the namespace and the action name in the
   * jsaction attribute value.
   */
  NAMESPACE_ACTION_SEPARATOR: '.',

  /**
   * The separator between the event name and action in the jsaction
   * attribute value.
   */
  EVENT_ACTION_SEPARATOR: ':',

  /**
   * The separator between the logged oi attribute values in the &oi=
   * URL parameter value.
   */
  OI_SEPARATOR: '.',

  /**
   * The separator between the key and the value pairs in the &cad=
   * URL parameter value.
   */
  CAD_KEY_VALUE_SEPARATOR: ':',

  /**
   * The separator between the key-value pairs in the &cad= URL
   * parameter value.
   */
  CAD_SEPARATOR: ','
};

/**
 * Names of events that are special to jsaction. These are not all
 * event types that are legal to use in either HTML or the addEvent()
 * API, but these are the ones that are treated specially. All other
 * DOM events can be used in either addEvent() or in the value of the
 * jsaction attribute. Beware of browser specific events or events
 * that don't bubble though: If they are not mentioned here, then
 * event contract doesn't work around their peculiarities.
 * @enum {string}
 */
exports.EventType = {
  /**
   * The click event. In addEvent() refers to all click events, in the
   * jsaction attribute it refers to the unmodified click and Enter/Space
   * keypress events.  In the latter case, a jsaction click will be triggered,
   * for accessibility reasons.  See clickmod and clickonly, below.
   */
  CLICK: 'click',

  /**
   * Specifies the jsaction for a modified click event (i.e. a mouse
   * click with the modifier key Cmd/Ctrl pressed). This event isn't
   * separately enabled in addEvent(), because in the DOM, it's just a
   * click event.
   */
  CLICKMOD: 'clickmod',

  /**
   * Specifies the jsaction for a click-only event.  Click-only doesn't take
   * into account the case where an element with focus receives an Enter/Space
   * keypress.  This event isn't separately enabled in addEvent().
   */
  CLICKONLY: 'clickonly',

  /**
   * Focus doesn't bubble, but you can use it in addEvent() and
   * jsaction anyway. EventContract does the right thing under the
   * hood.
   */
  FOCUS: 'focus',

  /**
   * This event only exists in IE. For addEvent() and jsaction, use
   * focus instead; EventContract does the right thing even though
   * focus doesn't bubble.
   */
  FOCUSIN: 'focusin',

  /**
   * Analog to focus.
   */
  BLUR: 'blur',

  /**
   * Analog to focusin.
   */
  FOCUSOUT: 'focusout',

  /**
   * Submit doesn't bubble, so it cannot be used with event
   * contract. However, the browser helpfully fires a click event on
   * the submit button of a form (even if the form is not submitted by
   * a click on the submit button). So you should handle click on the
   * submit button instead.
   */
  SUBMIT: 'submit',

  /**
   * The keydown event. In addEvent() and non-click jsaction it represents the
   * regular DOM keydown event. It represents click actions in non-Gecko
   * browsers.
   */
  KEYDOWN: 'keydown',

  /**
   * The keypress event. In addEvent() and non-click jsaction it represents the
   * regular DOM keypress event. It represents click actions in Gecko browsers.
   */
  KEYPRESS: 'keypress',

  /**
   * The mouseover event. Can either be used directly or used implicitly to
   * capture mouseenter events. In addEvent(), it represents a regular DOM
   * mouseover event.
   */
  MOUSEOVER: 'mouseover',

  /**
   * The mouseout event. Can either be used directly or used implicitly to
   * capture mouseover events. In addEvent(), it represents a regular DOM
   * mouseout event.
   */
  MOUSEOUT: 'mouseout',

  /**
   * The mouseenter event. Does not bubble and fires individually on each
   * element being entered within a DOM tree.
   */
  MOUSEENTER: 'mouseenter',

  /**
   * The mouseleave event. Does not bubble and fires individually on each
   * element being entered within a DOM tree.
   */
  MOUSELEAVE: 'mouseleave',

  /**
   * The error event. The error event doesn't bubble, but you can use it in
   * addEvent() and jsaction anyway. EventContract does the right thing under
   * the hood (except in IE8 which does not use error events).
   */
  ERROR: 'error',

  /**
   * The load event. The load event doesn't bubble, but you can use it in
   * addEvent() and jsaction anyway. EventContract does the right thing
   * under the hood.
   */
  LOAD: 'load',

  /**
   * The touchstart event. Bubbles, will only ever fire in browsers with
   * touch support.
   */
  TOUCHSTART: 'touchstart',

  /**
   * The touchend event. Bubbles, will only ever fire in browsers with
   * touch support.
   */
  TOUCHEND: 'touchend',

  /**
   * The touchmove event. Bubbles, will only ever fire in browsers with
   * touch support.
   */
  TOUCHMOVE: 'touchmove',

  /**
   * A custom event. The actual custom event type is declared as the 'type'
   * field in the event details. Supported in Firefox 6+, IE 9+, and all Chrome
   * versions.
   *
   * This is an internal name. Users should use jsaction.fireCustomEvent to
   * fire custom events instead of relying on this type to create them.
   */
  CUSTOM: '_custom'
};

/**
 * Special keycodes used by jsaction for the generic click action.
 * @enum {number}
 */
exports.KeyCodes = {
  /**
   * If on a Macintosh with an extended keyboard, the Enter key located in the
   * numeric pad has a different ASCII code.
   */
  MAC_ENTER: 3,

  /**
   * The Enter key.
   */
  ENTER: 13,

  /**
   * The Space key.
   */
  SPACE: 32
};

/**
 * Special tag names used by jsaction for the generic click action.
 * @enum {string}
 */
exports.TagName = {
  /**
   * A textarea tag.
   */
  TEXTAREA: 'TEXTAREA',

  /**
   * An input tag.
   */
  INPUT: 'INPUT',

  /**
   * A button tag.
   */
  BUTTON: 'BUTTON',

  /**
   * An anchor tag.
   */
  A: 'A'
};

/**
 * Special names used by jsaction.
 * @enum {string}
 */
exports.Name = {
  /**
   * The start time property of ActionFlow. TODO(user): Maybe a Property?
   */
  START: 'start',

  /**
   * Click additional data.
   */
  CAD: 'cad',

  /**
   * Action data to track duplicate ticks. This is used as a key in
   * additionalData map and in the value of the CLICK_ADDITIONAL_DATA
   * URL parameter in the reporting request.
   */
  DUP: 'dup'
};

/**
 * All the CSI ticks issued by jsaction.
 * @enum {string}
 */
exports.Tick = {
  /**
   * Tick that indicates that the control flow enters ActionFlow.impression().
   */
  IMP0: 'imp0',

  /**
   * Tick that indicates that the control flow leaves impression().
   */
  IMP1: 'imp1'
};

/**
 * All properties that are used by jsaction.
 * @enum {string}
 */
exports.Property = {
  /**
   * The parsed value of the jsaction attribute is stored in this
   * property on the DOM node. The parsed value is an Object. The
   * property names of the object are the events; the values are the
   * names of the actions. This property is attached even on nodes
   * that don't have a jsaction attribute as an optimization, because
   * property lookup is faster than attribute access.
   */
  JSACTION: '__jsaction',

  /**
   * The parsed value of the jsnamespace attribute is stored in this
   * property on the DOM node.
   */
  JSNAMESPACE: '__jsnamespace',

  /**
   * The value of the oi attribute as a property, for faster access.
   */
  OI: '__oi',

  /**
   * The owner property references an a logical owner for a DOM node. JSAction
   * will follow this reference instead of parentNode when traversing the DOM
   * to find jsaction attributes. This allows overlaying a logical structure
   * over a document where the DOM structure can't reflect that structure.
   */
  OWNER: '__owner'
};

exports.UrlParam = {
  /**
   * The type of the click is the name of the jsaction it was mapped to.
   */
  CLICK_TYPE: 'ct',

  /**
   * Click data contains the positional index of the clicked element
   * among its sibling as given by the jsinstance attribute value, if
   * any.
   */
  CLICK_DATA: 'cd',

  /**
   * Contains more structured data registered during the execution of
   * the jsaction handler and registered with the ActionFlow
   * instance. Among these data is informaiton about impressions that
   * were generated during the handling of the jsaction.
   */
  CLICK_ADDITIONAL_DATA: 'cad',

  /**
   * The event ID of the response that generated the clicked element,
   * as obtained from the value of the jstrack attribute.
   */
  EVENT_ID: 'ei',

  /**
   * The visual element data for the clicked element, as obtained from
   * the ved attribute.
   */
  VISUAL_ELEMENT_CLICK: 'ved',

  /**
   * The visual element type of the clicked element, as obtained from the vet
   * attribute.
   */
  VISUAL_ELEMENT_TYPE: 'vet'
};


/***/ },

/***/ 19:
/***/ function(module, exports, __webpack_require__) {

/*jshint -W030 */

/**
 * Records information for later handling of events. This type is
 * shared, and instances of it are passed, between the eventcontract
 * and the dispatcher jsbinary. Therefore, the fields of this type are
 * referenced by string literals rather than property literals
 * throughout the code.
 *
 * 'targetElement' is the element the action occured on, 'actionElement'
 * is the element that has the jsaction handler.
 *
 * A null 'actionElement' identifies an EventInfo instance that didn't match a
 * jsaction attribute.  This allows us to execute global event handlers with the
 * appropriate event type (including a11y clicks and custom events).
 *
 * TODO(user): Using literals to access properties makes type
 * checking partially ineffective. Accessing a wrongly spelled field
 * this way doesn't create a compiler error, and passing such an
 * untyped field to a place where a type is expected doesn't create a
 * jscompiler error either. Assigning a value of the wrong type in
 * this way, however, does trigger a jscompiler error (seen when
 * assigning Event to 'target', which requires !Event).
 *
 * @typedef {{
 *   eventType: string,
 *   event: !Event,
 *   targetElement: !Element,
 *   action: string,
 *   actionElement: Element,
 *   timeStamp: number
 * }}
 */
exports.EventInfo;

/**
 * Records action information for a given event.  Since this type is only used
 * internally by the EventContract, we don't need to reference fields with
 * string literals (as opposed to jsaction.EventInfo).
 *
 * An empty 'action' identifies an ActionInfo instance that didn't match a
 * jsaction attribute.  This allows us to execute global event handlers with the
 * appropriate event type (including a11y clicks and custom events).
 *
 * @typedef {{
 *   eventType: string,
 *   action: string,
 *   ignore: boolean
 * }}
 */
exports.ActionInfo;

/**
 * The type of a DOM event handler function.
 * @typedef {function(this: Element, !Event)}
 */
exports.EventHandlerFunction;

/**
 * Information about a registered event handler, which can be used to
 * deregister the event handler.
 *
 * @typedef {{
 *   eventType: string,
 *   handler: ./typedefs.EventHandlerFunction,
 *   capture: boolean
 * }}
 */
exports.EventHandlerInfo;

/**
 * A function used to initialze containers in
 * EventContract.addContainer(). Such a function is passed an HTML DOM
 * Element and registers a specific event handler onm it. The
 * EventHandlerInfo that is needed to eventually deregister the evetn
 * handler is returned by that function.
 * @typedef {function(!Element):./typedefs.EventHandlerInfo}
 */
exports.ContainerInitializerFunction;


/***/ },

/***/ 25:
/***/ function(module, exports, __webpack_require__) {

// Copyright 2011 Google Inc. All Rights Reserved.

'use strict';

/*jshint -W089 */
/*
 * Copying prototype properties is needed.
 */

/**
 *
 * @fileoverview Functions that help jsaction deal with browser
 * events. We deliberately don't use the closure equivalents here
 * because we want to exercise very tight control over the
 * dependencies, because this code is meant to be inlined in the main
 * HTML page and therefore needs to be as small as possible.
 */

var base = __webpack_require__(2);
var dom = __webpack_require__(44);
var EventType = __webpack_require__(4).EventType;
var KeyCodes = __webpack_require__(4).KeyCodes;
__webpack_require__(19);

/**
 * HTML controls for which to not call preventDefault when space is pressed.
 * @type {!Object.<string, number>}
 * @const
 */
var PROCESS_SPACE = {
  'CHECKBOX': 1,
  'OPTION': 1,
  'RADIO': 1
};

/**
 * Mapping of HTML element identifiers (ARIA role, type, or tagName) to the
 * keys (enter and/or space) that should activate them. A value of zero means
 * that both should activate them.
 * @type {!Object.<string, number>}
 * @const
 */
var IDENTIFIER_TO_KEY_TRIGGER_MAPPING = {
  'A': KeyCodes.ENTER,
  'BUTTON': 0,
  'CHECKBOX': KeyCodes.SPACE,
  'COMBOBOX': KeyCodes.ENTER,
  'LINK': KeyCodes.ENTER,
  'LISTBOX': KeyCodes.ENTER,
  'MENU': 0,
  'MENUBAR': 0,
  'MENUITEM': 0,
  'MENUITEMCHECKBOX': 0,
  'MENUITEMRADIO': 0,
  'OPTION': KeyCodes.ENTER,
  'RADIO': KeyCodes.SPACE,
  'RADIOGROUP': KeyCodes.SPACE,
  'RESET': 0,
  'SUBMIT': 0,
  'TAB': 0,
  'TABLIST': 0,
  'TREE': KeyCodes.ENTER,
  'TREEITEM': KeyCodes.ENTER
};

/**
 * Registers the event handler function with the given DOM element for
 * the given event type. This function correctly handles registering
 * event handlers in IE using attachEvent(), and it properly deals
 * with the peculiar propagation of focus and blur.
 *
 * @param {!Element} element The element.
 * @param {string} eventType The event type.
 * @param {./typedefs.EventHandlerFunction} handler The handler function
 *     to install.
 * @return {./typedefs.EventHandlerInfo} Information needed to uninstall
 *     the event handler eventually.
 */
function addEventListener(element, eventType, handler) {
  // In the W3C DOM, all event handlers are registered in the bubbling
  // phase for compatibility with the IE event model, which only has a
  // bubbling phase. (IE's event API has event capture, but that's
  // something different.)
  //
  // The exception is focus and blur. For backwards compatibility with
  // the pre-bubbling event handlers, these events don't bubble at
  // all. The two event models compensate differently for this
  // limitation: IE provides a bubbling variant of these events,
  // focusin and focusout. W3C propagates focus and blur, but *only*
  // in the capturing phase, and it doesn't define focusin and
  // focusout.
  //
  // Therefore, the event contract handlers for focus and blur must be
  // treated special:
  //
  // * In W3C, we register them in the capture phase. This fact is
  //   recorded in EventInfo, so we can properly deregister them.
  //
  // * In IE, we register focusin and focuout, respectively. This fact
  //   is also recorded in EventInfo, so that it can be properly
  //   deregistered.
  //
  // It would be a bad idea to register all event handlers in the
  // capture phase because then regular onclick handlers would not be
  // executed at all on events that trigger a jsaction. That's not
  // entirely what we want, at least for now.
  //
  // Error and load events (i.e. on images) do not bubble so they are also
  // handled in the capture phase. These errors are also not supported in IE8
  // but we set them up here to be used in newer browsers.
  var capture = false;

  // Mouseenter and mouseleave events are not handled directly because they
  // are not available everywhere. In browsers where they are available, they
  // don't bubble and aren't visible at the container boundary. Instead, we
  // synthesize the mouseenter and mouseleave events from mouseover and
  // mouseout events, respectively. Cf. eventcontract.js.
  if (eventType == EventType.MOUSEENTER) {
    eventType = EventType.MOUSEOVER;
  } else if (eventType == EventType.MOUSELEAVE) {
    eventType = EventType.MOUSEOUT;
  }

  if (element.addEventListener) {
    if (eventType == EventType.FOCUS ||
        eventType == EventType.BLUR ||
        eventType == EventType.ERROR ||
        eventType == EventType.LOAD) {
      capture = true;
    }
    element.addEventListener(
        eventType, /** @type {EventListener} */(handler), capture);

  } else if (element.attachEvent) {
    if (eventType == EventType.FOCUS) {
      eventType = EventType.FOCUSIN;
    } else if (eventType == EventType.BLUR) {
      eventType = EventType.FOCUSOUT;
    }
    // IE doesn't call handler as method of element (thus 'this' isn't
    // set to element), and doesn't pass the Event instance as
    // argument. The adapter used here takes care of both.
    //
    // It's important that this adapter is deregistered eventually,
    // otherwise it constitutes a memory leak.
    //
    // Redefining the argument handler is done for utmost
    // conciseness. Better style would be more verbose. This needs to
    // be done such that the adapter rather than the original handler
    // is returned in event info, because that must be used to
    // eventually unregister this handler.
    handler = attachEventAdapter_(element, handler);
    element.attachEvent('on' + eventType, handler);
  }
  return { eventType: eventType, handler: handler, capture: capture };
}

/**
 * In an event handler registered in IE, 'this' doesn't refer to the
 * Element the event handler is bound to, and the Event instance isn't
 * passed to the event handler as an argument, but is in the global
 * property window.event. This creates a wrapper around an normal
 * event handler that adapts these two aspects.
 *
 * It's important that this adapter is deregistered eventually,
 * otherwise it will create a memory leak.
 *
 * @param {!Element} target The Element instance on which the handler
 *     is installed.
 * @param {./typedefs.EventHandlerFunction} handler The handler to adapt
 *     to.
 * @return {./typedefs.EventHandlerFunction} The adapted handler
 *     function.
 * @private
 */
function attachEventAdapter_(target, handler) {
  return function (e) {
    // Internet Explorer passes the event details through the global
    // window.event property. Although this handler wrapper is meant
    // to be used in IE, it actually is used when the attachEvent()
    // method is present. This is the case at least in Opera/7 on the
    // window object. Thus, we again detect features here, not
    // browsers.
    if (!e) {
      e = window.event;
    }
    return handler.call(target, e);
  };
}

/**
 * Removes the event handler for the given event from the element.
 * the given event type.
 *
 * @param {!Element} element The element.
 * @param {./typedefs.EventHandlerInfo} info The information
 *     needed to deregister the handler, as returned by
 *     addEventListener(), above.
 */
function removeEventListener(element, info) {
  if (element.removeEventListener) {
    element.removeEventListener(
        info.eventType,
        /** @type {EventListener} */(info.handler),
        info.capture);
  } else if (element.detachEvent) {
    element.detachEvent('on' + info.eventType, info.handler);
  }
}

/**
 * Cancels propagation of an event.
 * @param {!Event} e The event to cancel propagation for.
 */
function stopPropagation(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  } else {
    e.cancelBubble = true;
  }
}

/**
 * Prevents the default action of an event.
 * @param {!Event} e The event to prevent the default action for.
 */
function preventDefault(e) {
  if (e.preventDefault) {
    e.preventDefault();
  } else {
    e.returnValue = false;
  }
}

/**
 * Gets the target of the event.  In IE8 and older the 'target' property
 * is not support and the 'srcElement' property has to be used instead.
 * @param {!Event} e The event to get the target of.
 * @return {!Element} The target element.
 */
function getTarget(e) {
  var target = e.target || e.srcElement;
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }
  return /** @type {!Element} */ target;
}

/**
 * Whether we are on a Mac. Not pulling in useragent just for this.
 * NOTE(izaakr): navigator does not exist in google_js_test, hence the test
 * for its existence.
 * @type {boolean}
 * @private
 */
var isMac_ = typeof navigator != 'undefined' &&
    /Macintosh/.test(navigator.userAgent);

/**
 * Determines and returns whether the given event (which is assumed to be a
 * click event) is a middle click.
 * NOTE(user): There is not a consistent way to identify middle click
 * across all browsers. Some detailed information about this can be found at:
 * http://www.unixpapa.com/js/mouse.html
 * @param {!Event} e The event.
 * @return {boolean} Whether the given event is a middle click.
 * @private
 */
function isMiddleClick_(e) {
  return (e.which == 2) ||
      /* middle click for IE */
      ((e.which === null || e.which === undefined) && e.button == 4);
}

/**
 * Determines and returns whether the given event (which is assumed
 * to be a click event) is modified. A middle click is considered a modified
 * click to retain the default browser action, which opens a link in a new tab.
 * @param {!Event} e The event.
 * @return {boolean} Whether the given event is modified.
 */
function isModifiedClickEvent(e) {
  var isMac = (false) ? module.exports.isMac_ : isMac_;
  return (isMac && e.metaKey) ||
      (!isMac && e.ctrlKey) ||
      isMiddleClick_(e) ||
      e.shiftKey;
}

/**
 * Whether we are on WebKit (e.g., Chrome).
 * @type {boolean}
 * @private
 */
var isWebKit_ = typeof navigator != 'undefined' &&
    !/Opera/.test(navigator.userAgent) &&
    /WebKit/.test(navigator.userAgent);

/**
 * Whether we are on Gecko (e.g., Firefox).
 * @type {boolean}
 */
var isGecko = typeof navigator != 'undefined' &&
    !/Opera|WebKit/.test(navigator.userAgent) &&
    /Gecko/.test(navigator.product);

/**
 * Determines and returns whether the given element is a valid target for
 * keypress/keydown DOM events that act like regular DOM clicks.
 * @param {!Element} element The element.
 * @return {boolean} Whether the given element is a valid action key target.
 * @private
 */
function isValidActionKeyTarget_(element) {
  if (!('getAttribute' in element)) {
    return false;
  }
  var tagName = (
      element.getAttribute('role') || element.type || element.tagName).
      toUpperCase();
  return tagName != 'TEXT' &&
      tagName != 'TEXTAREA' &&
      tagName != 'PASSWORD' &&
      tagName != 'SEARCH' &&
      (tagName != 'COMBOBOX' || element.tagName.toUpperCase() != 'INPUT') &&
      !element.isContentEditable;
}

/**
 * Whether an event has a modifier key activated.
 * @param {!Event} e The event.
 * @return {boolean} True, if a modifier key is activated.
 * @private
 */
function hasModifierKey_(e) {
  return e.ctrlKey || e.shiftKey || e.altKey || e.metaKey;
}

/**
 * Determines and returns whether the given event has a target that already
 * has event handlers attached because it is a native HTML control. Used to
 * determine if preventDefault should be called when isActionKeyEvent is true.
 * @param {!Event} e The event.
 * @return {boolean} If preventDefault should be called.
 */
function shouldCallPreventDefaultOnNativeHtmlControl(e) {
  var el = getTarget(e);
  var elementName = (el.getAttribute('role') || el.tagName).toUpperCase();
  var type = el.type;
  return elementName == 'BUTTON' || !!type &&
      !(type.toUpperCase() in PROCESS_SPACE);
}

/**
 * Determines and returns whether the given event acts like a regular DOM click.
 * This is represented by a keypress (keydown on Gecko browsers) on Enter or
 * Space key.
 * @param {!Event} e The event.
 * @return {boolean} True, if the event emulates a DOM click.
 */
function isActionKeyEvent(e) {
  var key = e.which || e.keyCode || e.key;
  if (isWebKit_ && key == KeyCodes.MAC_ENTER) {
    key = KeyCodes.ENTER;
  }
  var el = getTarget(e);
  var id = (el.getAttribute('role') || el.type || el.tagName).toUpperCase();
  var kCodes = key == KeyCodes.ENTER || key == KeyCodes.SPACE;
  var validTypeMods = e.type == EventType.KEYDOWN &&
      isValidActionKeyTarget_(el) &&
      !hasModifierKey_(e);
  var noType = el.tagName.toUpperCase() == 'INPUT' && !el.type;
  var inMap = IDENTIFIER_TO_KEY_TRIGGER_MAPPING[id] % key === 0;
  var notInMap = !(id in IDENTIFIER_TO_KEY_TRIGGER_MAPPING) &&
      key == KeyCodes.ENTER;
  // To prevent false negatives when bubbling
  var origTar = !!e.originalTarget && e.originalTarget != el;
  return validTypeMods && kCodes && ((inMap || notInMap) && !noType || origTar);
}

/**
 * @param {!Event} e
 * @return {boolean} True, if the Space key was pressed.
 */
function isSpaceKeyEvent(e) {
  var key = e.which || e.keyCode || e.key;
  var el = getTarget(e);
  var elementName = (el.type || el.tagName).toUpperCase();
  return key == KeyCodes.SPACE && elementName != 'CHECKBOX';
}

/**
 * Determines whether the event corresponds to a non-bubbling mouse
 * event type (mouseenter and mouseleave).
 *
 * During mouseover (mouseenter), the relatedTarget is the element being
 * entered from. During mouseout (mouseleave), the relatedTarget is the
 * element being exited to.
 *
 * In both cases, if relatedTarget is outside target, then the corresponding
 * special event has occurred, otherwise it hasn't.
 *
 * @param {!Event} e The mouseover/mouseout event.
 * @param {string} type The type of the mouse special event.
 * @param {!Element} element The element on which the jsaction for the
 *     mouseenter/mouseleave event is defined.
 * @return {boolean} True if the event is a mouseenter/mouseleave event.
 */
function isMouseSpecialEvent(e, type, element) {
  var related = /** @type {!Node} */ (e.relatedTarget);

  return ((e.type == EventType.MOUSEOVER &&
           type == EventType.MOUSEENTER) ||
          (e.type == EventType.MOUSEOUT &&
           type == EventType.MOUSELEAVE)) &&
          (!related || (related !== element &&
           !dom.contains(element, related)));
}

/**
 * Creates a new EventLike object for a mouseenter/mouseleave event that's
 * derived from the original corresponding mouseover/mouseout event.
 * @param {!Event} e The event.
 * @param {!Element} target The element on which the jsaction for the
 *     mouseenter/mouseleave event is defined.
 * @return {!Object} A modified event-like object copied from the event object
 *     passed into this function.
 */
function createMouseSpecialEvent(e, target) {
  // We have to create a copy of the event object because we need to mutate
  // its fields. We do this for the special mouse events because the event
  // target needs to be retargeted to the action element rather than the real
  // element (since we are simulating the special mouse events with mouseover/
  // mouseout).
  //
  // Since we're making a copy anyways, we might as well attempt to convert
  // this event into a pseudo-real mouseenter/mouseleave event by adjusting
  // its type.
  var copy = {};

  for (var i in e) {
    if (typeof e[i] === 'function' || i === 'srcElement' || i === 'target') {
      continue;
    }
    copy[i] = e[i];
  }

  if (e.type == EventType.MOUSEOVER) {
    copy['type'] = EventType.MOUSEENTER;
  } else {
    copy['type'] = EventType.MOUSELEAVE;
  }
  copy['target'] = copy['srcElement'] = target;
  copy['bubbles'] = false;
  return copy;
}

/**
 * Returns a copy of the event that is safe to keep a reference to.
 * For all non-IE browsers, it is safe to keep the existing event, but
 * since older versions of IE reuse and clobber the same Event object
 * each time a handler is called, we need to make an explicit copy.
 *
 * @param {!Event} e The event to be copied.
 * @return {!Event} The event copy.
 * TODO(user): Add tests for this function.
 */
function maybeCopyEvent(e) {
  var doc = base.global['document'];
  // We test the following:
  //
  // The document may not exist in dom-less tests.
  //
  // The absence of document.createEvent signals that we're on an
  // older version of IE, which needs to copy the event.  In contrast,
  // when document.createEvent is defined we do not have to copy.
  //
  // The method document.createEventObject, if present, is the IE supported
  // way to copy the event but it should only be used in older versions of
  // IE, ones which do not define document.createEvent.
  //
  // Doc.createEventObject fails for non-browser events (such as custom events),
  // but those do not require copying, so we just return the existing event.
  //
  // NOTE(user): document.createEventObject is deprecated since IE 9. Its
  // usage is disallowed in IE 9 standards document mode. More information at
  // http://msdn.microsoft.com/en-us/library/ff986080(v=vs.85)
  if (doc && !doc.createEvent && doc.createEventObject) {
    try {
      return doc.createEventObject(e);
    } catch (ignore) {
      // Copying the event fails. Assume that this is because the event was
      // not a browser event and thus does not require copying.
      return e;
    }
  } else {
    return e;
  }
}

module.exports = {
  addEventListener: addEventListener,
  attachEventAdapter_: attachEventAdapter_,
  removeEventListener: removeEventListener,
  stopPropagation: stopPropagation,
  preventDefault: preventDefault,
  getTarget: getTarget,
  isMac_: isMac_,
  isMiddleClick_: isMiddleClick_,
  isModifiedClickEvent: isModifiedClickEvent,
  isWebKit_: isWebKit_,
  isGecko: isGecko,
  isValidActionKeyTarget_: isValidActionKeyTarget_,
  hasModifierKey_: hasModifierKey_,
  shouldCallPreventDefaultOnNativeHtmlControl:
      shouldCallPreventDefaultOnNativeHtmlControl,
  isActionKeyEvent: isActionKeyEvent,
  isSpaceKeyEvent: isSpaceKeyEvent,
  isMouseSpecialEvent: isMouseSpecialEvent,
  createMouseSpecialEvent: createMouseSpecialEvent,
  maybeCopyEvent: maybeCopyEvent,
  PROCESS_SPACE: PROCESS_SPACE
};


/***/ },

/***/ 44:
/***/ function(module, exports, __webpack_require__) {

// Copyright 2013 Google Inc. All Rights Reserved.

/**
 * @fileoverview Functions that help jsaction interact with the DOM. We
 * deliberately don't use the closure equivalents here because we want
 * to exercise very tight control over the dependencies.
 */

'use strict';

/**
 * Determines if one node is contained within another. Adapted from
 * {@see goog.dom.contains}.
 * @param {!Node} node Node that should contain otherNode.
 * @param {Node} otherNode Node being contained.
 * @return {boolean} True if otherNode is contained within node.
 */
function contains(node, otherNode) {
  if (otherNode === null) {
    return false;
  }

  // We use browser specific methods for this if available since it is faster
  // that way.

  // IE DOM
  if ('contains' in node && otherNode.nodeType == 1) {
    return node.contains(otherNode);
  }

  // W3C DOM Level 3
  if ('compareDocumentPosition' in node) {
    return node == otherNode ||
        Boolean(node.compareDocumentPosition(otherNode) & 16);
  }

  // W3C DOM Level 1
  while (otherNode && node != otherNode) {
    otherNode = otherNode.parentNode;
  }
  return otherNode == node;
}

module.exports = {
  contains: contains
};


/***/ },

/***/ 190:
/***/ function(module, exports, __webpack_require__) {

// Copyright 2013 Google Inc. All Rights Reserved.

'use strict';

/**
 * @fileoverview A small library to share functions to get and set
 * jsaction parser cache entries.
 */

var Property = __webpack_require__(4).Property;

var Cache = {};

/**
 * Reads the jsaction parser cache from the given DOM Element.
 *
 * @param {!Element} element .
 * @return {!Object.<string, string>} Map from event to qualified name
 *     of the jsaction bound to it.
 */
Cache.get = function (element) {
  return element[Property.JSACTION];
};

/**
 * Writes the jsaction parser cache to the given DOM Element.
 *
 * @param {!Element} element .
 * @param {!Object.<string, string>} actionMap Map from event to
 *     qualified name of the jsaction bound to it.
 */
Cache.set = function (element, actionMap) {
  element[Property.JSACTION] = actionMap;
};

/**
 * Clears the jsaction parser cache from the given DOM Element.
 *
 * @param {!Element} element .
 */
Cache.clear = function (element) {
  if (Property.JSACTION in element) {
    delete element[Property.JSACTION];
  }
};

/**
 * Reads the cached jsaction namespace from the given DOM
 * Element. Undefined means there is no cached value; null is a cached
 * jsnamespace attribute that's absent.
 *
 * @param {!Element} element .
 * @return {string|null|undefined} .
 */
Cache.getNamespace = function (element) {
  return element[Property.JSNAMESPACE];
};

/**
 * Writes the cached jsaction namespace to the given DOM Element. Null
 * represents a jsnamespace attribute that's absent.
 *
 * @param {!Element} element .
 * @param {?string} jsnamespace .
 */
Cache.setNamespace = function (element, jsnamespace) {
  element[Property.JSNAMESPACE] = jsnamespace;
};

/**
 * Clears the cached jsaction namespace from the given DOM Element.
 *
 * @param {!Element} element .
 */
Cache.clearNamespace = function (element) {
  if (Property.JSNAMESPACE in element) {
    delete element[Property.JSNAMESPACE];
  }
};

module.exports = Cache;


/***/ },

/***/ 192:
/***/ function(module, exports, __webpack_require__) {

// Copyright 2005 Google Inc. All Rights Reserved.

/**
 *
 * @fileoverview Implements the local event handling contract. This
 * allows DOM objects in a container that enters into this contract to
 * define event handlers which are executed in a local context.
 *
 * One EventContract instance can manage the contract for multiple
 * containers, which are added using the addContainer() method.
 *
 * Events can be registered using the addEvent() method.
 *
 * A Dispatcher is added using the dispatchTo() method. Until there is
 * a dispatcher, events are queued. The idea is that the EventContract
 * class is inlined in the HTML of the top level page and instantiated
 * right after the start of <body>. The Dispatcher class is contained
 * in the external deferred js, and instantiated and registered with
 * EventContract when the external javascript in the page loads. The
 * external javascript will also register the jsaction handlers, which
 * then pick up the queued events at the time of registration.
 *
 * Since this class is meant to be inlined in the main page HTML, the
 * size of the binary compiled from this file MUST be kept as small as
 * possible and thus its dependencies to a minimum.
 */

'use strict';

var Cache = __webpack_require__(190);
var domGenerator = __webpack_require__(193);
var jsActionEvent = __webpack_require__(25);
var Attribute = __webpack_require__(4).Attribute;
var Char = __webpack_require__(4).Char;
var EventType = __webpack_require__(4).EventType;
var Property = __webpack_require__(4).Property;
__webpack_require__(19);

/**
 * A class representing a container node and all the event handlers
 * installed on it. Used so that handlers can be cleaned up if the
 * container is removed from the contract.
 *
 * @param {!Element} div The container node. Usually a div but not
 *     constrained to be.
 * @constructor
 */
var EventContractContainer = function (div) {
  /**
   * @type {!Element}
   */
  this.div = div;

  /**
   * Array of event handlers and their corresponding event types that are
   * installed on this container.
   *
   * @type {!Array.<./typedefs.EventHandlerInfo>}
   * @private
   */
  this.handlers_ = [];
};

/**
 * @param {Node} node Candidate child node.
 * @return {boolean} True if this container has node as a child.
 */
EventContractContainer.prototype.containsNode = function (node) {
  return EventContractContainer.containsNode_(this.div, node);
};

/**
 * Checks whether the container is a child of any of the containers in the
 * given list.
 * @param {!EventContractContainer} container The container to check.
 * @param {!Array.<!EventContractContainer>} list The list of all the
 *    containers to check against for nesting.
 * @return {boolean} True if the container is nested.
 * @private
 */
EventContractContainer.isNested_ = function (container, list) {
  for (var i = 0; i < list.length; ++i) {
    if (list[i].div == container.div) {
      continue;
    }

    if (list[i].containsNode(container.div)) {
      return true;
    }
  }

  return false;
};

/**
 * Determines whether one node is the parent of the other.
 * @param {Node} parent The parent node.
 * @param {Node} child The node to look for in parent.
 * @return {boolean} parent recursively contains child.
 * @private
 */
EventContractContainer.containsNode_ = function (parent, child) {
  while (parent != child && child.parentNode) {
    child = child.parentNode;
  }
  return parent == child;
};

/**
 * Installs the provided installer on the div owned by this container,
 * and maintains a reference to resulting handler in order to remove it
 * later if desired.
 *
 * @param {./typedefs.ContainerInitializerFunction} installer The
 *     installer returned by
 *     EventContract.containerHandlerInstaller_.
 */
EventContractContainer.prototype.installHandler = function (installer) {
  this.handlers_.push(installer.call(null, this.div));
};

/**
 * Removes all the handlers installed on this container.
 */
EventContractContainer.prototype.cleanUp = function () {
  for (var i = 0; i < this.handlers_.length; ++i) {
    var handlerInfo = this.handlers_[i];
    jsActionEvent.removeEventListener(this.div, handlerInfo);
  }

  this.handlers_ = [];
};

/**
 * EventContract intercepts events in the bubbling phase at the
 * boundary of a container element, and maps them to generic actions
 * which are specified using the custom jsaction attribute in
 * HTML. Behavior of the application is then specified in terms of
 * handler for such actions, cf. jsaction.Dispatcher in dispatcher.js.
 *
 * This has several benefits: (1) No DOM event handlers need to be
 * registered on the specific elements in the UI. (2) The set of
 * events that the application has to handle can be specified in terms
 * of the semantics of the application, rather than in terms of DOM
 * events. (3) Invocation of handlers can be delayed and handlers can
 * be delay loaded in a generic way.
 *
 * @constructor
 */
function EventContract() {
  /**
   * A list of functions. Each function will initialize a newly
   * registered contract for one event. See addContainer().
   *
   * @type {!Array.<!./typedefs.ContainerInitializerFunction>}
   * @private
   */
  this.installers_ = [];

  /**
   * The containers signed up for this event contract. See addContainer().
   *
   * @type {!Array.<!EventContractContainer>}
   * @private
   */
  this.containers_ = [];

  /**
   * The list of containers that are children of an existing container. If
   * STOP_PROPAGATION is false then we do not install event listeners on these
   * (since that would cause the event to be triggered more than once). We do
   * want to keep track of these containers such that we properly handle
   * additions/removals.
   * If STOP_PROPAGATION is true it is safe to add event listeners on all the
   * containers.
   * @type {!Array.<!EventContractContainer>}
   * @private
   */
  this.nestedContainers_ = [];

  /**
   * The DOM events which this contract covers. Used to prevent double
   * registration of event types. The value of the map is the
   * internally created DOM event handler function that handles the
   * DOM events. See addEvent().
   *
   * @type {!Object.<string, !./typedefs.EventHandlerFunction>}
   * @private
   */
  this.events_ = {};

  /**
   * The dispatcher function. Events are passed to this function for
   * handling once it was set using the dispatchTo() method. Usually
   * the dispatcher is the bound dispatch() method of a
   * jsaction.Dispatcher instance. This is done because the function
   * is passed from another jsbinary, so passing the instance and
   * invoking the method here would require to leave the method
   * unobfuscated.
   *
   * @type {?function((!./typedefs.EventInfo|!Array.<!./typedefs.EventInfo>),
   *                  boolean=)}
   * @private
   */
  this.dispatcher_ = null;

  /**
   * The queue of events. Events are queued while there is no
   * dispatcher set.
   * @type {Array.<!./typedefs.EventInfo>}
   * @private
   */
  this.queue_ = [];

  if (EventContract.CUSTOM_EVENT_SUPPORT) {
    this.addEvent(EventType.CUSTOM);
  }
}

/**
 * @define {boolean} Controls the use of event.path logic for the dom
 * walking in createEventInfo_.
 */
EventContract.USE_EVENT_PATH = true;

/**
 * Whether the user agent is running on iOS.
 * @type {boolean}
 * @private
 */
EventContract.isIos_ = typeof navigator != 'undefined' &&
    /iPhone|iPad|iPod/.test(navigator.userAgent);

/**
 * @define {boolean} Support for jsnamespace attribute.  This flag can be
 *     overriden in a build rule to trim down the EventContract's binary size.
 */
EventContract.JSNAMESPACE_SUPPORT = true;

/**
 * @define {boolean} Support for accessible click actions.  This flag can be
 *     overriden in a build rule.
 */
EventContract.A11Y_CLICK_SUPPORT = true;

/**
 * @define {boolean} Support for the non-bubbling mouseenter and mouseleave
 *     events.  This flag can be overridden in a build rule.
 */
EventContract.MOUSE_SPECIAL_SUPPORT = true;

/**
 * @define {boolean} Simulate click events based on touch events for browsers
 *     that have a 300ms delay before they send the click event. This is
 *     currently EXPERIMENTAL.
 */
EventContract.FAST_CLICK_SUPPORT = false;

/**
 * @define {boolean} Call stopPropagation on handled events. When integrating
 *      with non-jsaction event handler based code, you will likely want to turn
 *      this flag off. While most event handlers will continue to work, jsaction
 *      binds focus and blur events in the capture phase and thus with
 *      stopPropagation, none of your non-jsaction-handlers will ever see it.
 */
EventContract.STOP_PROPAGATION = false;

/**
 * @define {boolean} Support for custom events, which are type
 *      EventType.CUSTOM. These are native DOM events with an
 *      additional type field and an optional payload.
 */
EventContract.CUSTOM_EVENT_SUPPORT = true;

/**
 * Specifies a click jsaction event type triggered by an Enter/Space DOM
 * keypress.
 * @type {string}
 * @const
 * @private
 */
EventContract.CLICKKEY_ = 'clickkey';

/**
 * Helper function to trim whitespace from the beginning and the end
 * of the string. This deliberately doesn't use the closure equivalent
 * to keep dependencies small.
 *
 * @param {string} str  Input string.
 * @return {string}  Trimmed string.
 * @private
 */
EventContract.stringTrim_ = function (str) {
  var trimmedLeft = str.replace(/^\s+/, '');
  return trimmedLeft.replace(/\s+$/, '');
};

/**
 * This regular expression matches a semicolon.
 * @type {RegExp}
 * @private
 * @const
 */
EventContract.REGEXP_SEMICOLON_ = /\s*;\s*/;

/**
 * The default event type.
 * @type {string}
 * @private
 */
EventContract.defaultEventType_ = EventType.CLICK;

/**
 * An element that received a touchstart event that we might want to translate
 * into a click event if a touchend event arrives.
 * @type {Element}
 * @private
 */
EventContract.fastClickNode_ = null;

/**
 * Elements for which we emitted "fast click" events, so that we need to ignore
 * subsequent click events. Elements are removed when the click events arrive.
 * At this point there may be a memory leak if we emit fast clicks in scenarios
 * that do not trigger a native click event.
 * @type {!Array.<!Element>}
 * @const
 * @private
 */
EventContract.fastClickedNodes_ = [];

/**
 * A timer that we schedule after a touchstart. If the timer fires before the
 * touchend event, the press is considered a long-press that does not get
 * translated into a click.
 * @type {number|undefined}
 * @private
 */
EventContract.fastClickTimeout_ = undefined;

/**
 * Gets the default event type.
 * @return {string} The default event type.
 */
EventContract.getDefaultEventType = function () {
  return EventContract.defaultEventType_;
};

/**
 * Sets a new default event type.
 * @param {string} eventType The new default event type.
 */
EventContract.setDefaultEventType = function (eventType) {
  EventContract.defaultEventType_ = eventType;
};

/**
 * Returns a function that handles events on a container and invokes a local
 * event handler (bound using the actions map) on the source node or any of
 * its ancestors up to the container to which the returned event handler
 * belongs. The local event handler is passed an ActionFlow which allows
 * access to the node, event, and values defined on the node. If there are no
 * jsaction handlers bound that can handle this event, the flow representing
 * the event is stored in a queue for replaying at a later time.
 *
 * @param {!EventContract} eventContract The EventContract
 *     instance to create this handler for.
 * @param {string} eventType The type of the event - e.g. 'click'.
 *     Note that event.type can differ from eventType. In some browsers (e.g.
 *     Firefox) the event handling code registers handlers for 'focusin' and
 *     'focusout' to handle 'focus' and 'blur' respectively. In those cases,
 *     event.type might be 'focus', but eventType will be 'focusin'.
 * @return {./typedefs.EventHandlerFunction} The DOM event handler to
 *     use for the given event type on all containers.
 * @private
 */
EventContract.eventHandler_ = function (eventContract, eventType) {
  /**
   * See description above.
   * @param {!Event} e Event.
   * @this {!Element}
   */
  var handler = function (e) {
    var container = this;
    // Store eventType's value in a local variable so that multiple calls do not
    // modify the shared eventType variable.
    var eventTypeForDispatch = eventType;
    if (EventContract.CUSTOM_EVENT_SUPPORT &&
        eventTypeForDispatch == EventType.CUSTOM) {
      // For custom events, use a secondary dispatch based on the internal
      // custom type of the event.
      if (!e.detail || !e.detail['_type']) {
        // This should never happen.
        return;
      }
      eventTypeForDispatch = e.detail['_type'];
    }

    var eventInfo = EventContract.createEventInfo_(
        eventTypeForDispatch, e, container);

    if (eventContract.dispatcher_) {
      var globalEventInfo = EventContract.createEventInfoInternal_(
          eventInfo['eventType'], eventInfo['event'],
          eventInfo['targetElement'], eventInfo['action'],
          eventInfo['actionElement'], eventInfo['timeStamp']);

      // In some cases, createEventInfo_() will rewrite click events to
      // clickonly.  Revert back to a regular click, otherwise we won't be able
      // to execute global event handlers registered on click events.
      if (globalEventInfo['eventType'] == EventType.CLICKONLY) {
        globalEventInfo['eventType'] = EventType.CLICK;
      }

      eventContract.dispatcher_(
          globalEventInfo, /* dispatch global event */ true);
    }

    // Return early if no action element found while walking up the DOM tree.
    if (!eventInfo['actionElement']) {
      return;
    }

    if (EventContract.STOP_PROPAGATION) {
      // Since we found a jsaction, prevent other handlers from seeing
      // this event.
      jsActionEvent.stopPropagation(e);
    }

    // Prevent browser from following <a> node links if a jsaction is
    // present. Note that the targetElement may be a child of an anchor that has
    // a jsaction attached. For that reason, we need to check the actionElement
    // rather than the targetElement.
    if (eventInfo['actionElement'].tagName == 'A' &&
        eventInfo['eventType'] == EventType.CLICK) {
      jsActionEvent.preventDefault(e);
    }

    if (eventContract.dispatcher_) {
      eventContract.dispatcher_(eventInfo);
    } else {
      var copiedEvent = jsActionEvent.maybeCopyEvent(e);
      // The event is queued since there is no dispatcher registered
      // yet. Potentially make a copy of the event in order to extend its
      // life. The copy will later be used when attempting to replay.
      eventInfo['event'] = copiedEvent;
      eventContract.queue_.push(eventInfo);
    }
  };
  return handler;
};

/**
 * Searches for a jsaction that the DOM event maps to and creates an
 * object containing event information used for dispatching by
 * jsaction.Dispatcher. The dispatch information returned consists of
 * the event type, target element, action and the Event instance
 * supplied by the DOM. The jsaction for the DOM event is the first
 * jsaction attribute above the target Node of the event, and below
 * the container Node, that specifies a jsaction for the event
 * type. If no such jsaction is found, the actionElement properties is null.
 *
 * @param {string} eventType The type of the event, e.g. 'click', as
 *     specified by event contract. This may differ from the DOM event
 *     type, because event contract may use more generic event types.
 * @param {!Event} e The Event instance received by the container from
 *     the DOM.
 * @param {!Node} container The container which limits the search for
 *     jsactions which can handle the event.
 * @return {./typedefs.EventInfo} The event info object.  If its actionElement
 *     property is null, no jsaction was found above the target Node of the
 *     event.
 * @private
 */
EventContract.createEventInfo_ = function (eventType, e, container) {
  // We distinguish modified and plain clicks in order to support the
  // default browser behavior of modified clicks on links; usually to
  // open the URL of the link in new tab or new window on ctrl/cmd
  // click. A DOM 'click' event is mapped to the jsaction 'click'
  // event iff there is no modifier present on the event. If there is
  // a modifier, it's mapped to 'clickmod' instead.
  //
  // It's allowed to omit the event in the jsaction attribute. In that
  // case, 'click' is assumed. Thus the following two are equivalent:
  //
  //   <a href="someurl" jsaction="gna.fu">
  //   <a href="someurl" jsaction="click:gna.fu">
  //
  // For unmodified clicks, EventContract invokes the jsaction
  // 'gna.fu'. For modified clicks, EventContract won't find a
  // suitable action and and leave the event to be handled by the
  // browser.
  //
  // In order to also invoke a jsaction handler for a modifier click,
  // 'clickmod' needs to be used:
  //
  //   <a href="someurl" jsaction="clickmod:gna.fu">
  //
  // EventContract invokes the jsaction 'gna.fu' for modified
  // clicks. Unmodified clicks are left to the browser.
  //
  // In order to set up the event contract to handle both clickonly and
  // clickmod, only addEvent(EventType.CLICK) is necessary.
  //
  // In order to set up the event contract to handle click,
  // addEvent() is necessary for CLICK, KEYDOWN, and KEYPRESS event types.  If
  // the EventContract.A11Y_CLICK_SUPPORT flag is turned on, addEvent()
  // will set up the appropriate key event handler automatically.
  if (eventType == EventType.CLICK &&
      jsActionEvent.isModifiedClickEvent(e)) {
    eventType = EventType.CLICKMOD;
  } else if (EventContract.A11Y_CLICK_SUPPORT &&
             jsActionEvent.isActionKeyEvent(e)) {
    eventType = EventContract.CLICKKEY_;
  }

  var target = /** @type {!Element} */jsActionEvent.getTarget(e);
  var eventInfo = EventContract.createEventInfoInternal_(
      eventType, e, target, '', null);

  // NOTE(user): In order to avoid complicating the code that calculates the
  // event's path, we need a common interface to iterating over event.path or
  // walking the DOM.  We use the generator pattern here, as generating the
  // path array ahead of time for DOM walks will result in degraded
  // performance.

  /** @type {./typedefs.ActionInfo} */
  var actionInfo;
  // NOTE(user): This is a work around some issues with custom dispatchers.
  var element;
  var node;
  if (EventContract.USE_EVENT_PATH) {
    var generator = domGenerator.getGenerator(
        e, target, /** @type {!Element} */(container));
    node = generator.next();
    while (node) {
      element = node;
      actionInfo = EventContract.getAction_(
          element, eventType, e, container);
      eventInfo = EventContract.createEventInfoInternal_(
          actionInfo.eventType, e, target, actionInfo.action || '', element,
          eventInfo['timeStamp']);

      // TODO(user): If we can get rid of the break on actionInfo.ignore
      // these loops can collapse down to one and the contents can live in
      // a function.
      // Stop walking the DOM prematurely if we will ignore this event.  This is
      // used solely for fastbutton's implementation.
      if (actionInfo.ignore ||
          // An event is handled by at most one jsaction. Thus we stop at
          // the first matching jsaction specified in a jsaction attribute
          // up the ancestor chain of the event target node.
          actionInfo.action) {
        break;
      }

      node = generator.next();
    }
  } else {
    for (node = target; node && node != container;
      // Walk to the parent node, unless the node has a different owner in
      // which case we walk to the owner.
      node = node[Property.OWNER] || node.parentNode) {
      element = node;
      actionInfo = EventContract.getAction_(
          element, eventType, e, container);
      eventInfo = EventContract.createEventInfoInternal_(
          actionInfo.eventType, e, target, actionInfo.action || '', element,
          eventInfo['timeStamp']);

      // Stop walking the DOM prematurely if we will ignore this event.  This is
      // used solely for fastbutton's implementation.
      if (actionInfo.ignore ||
          // An event is handled by at most one jsaction. Thus we stop at
          // the first matching jsaction specified in a jsaction attribute
          // up the ancestor chain of the event target node.
          actionInfo.action) {
        break;
      }
    }
  }

  if (actionInfo && actionInfo.action) {

    // Prevent scrolling if the Space key was pressed and prevent the browser's
    // default action for native HTML controls.
    if (EventContract.A11Y_CLICK_SUPPORT &&
        eventType == EventContract.CLICKKEY_ &&
        (jsActionEvent.isSpaceKeyEvent(e) ||
         jsActionEvent.shouldCallPreventDefaultOnNativeHtmlControl(e))) {
      jsActionEvent.preventDefault(e);
    }

    // We attempt to handle the mouseenter/mouseleave events here by
    // detecting whether the mouseover/mouseout events correspond to
    // entering/leaving an element.
    if (EventContract.MOUSE_SPECIAL_SUPPORT &&
        (eventType == EventType.MOUSEENTER ||
         eventType == EventType.MOUSELEAVE)) {
      // We attempt to handle the mouseenter/mouseleave events here by
      // detecting whether the mouseover/mouseout events correspond to
      // entering/leaving an element.
      if (jsActionEvent.isMouseSpecialEvent(e, eventType, element)) {
        // If both mouseover/mouseout and mouseenter/mouseleave events are
        // enabled, two separate handlers for mouseover/mouseout are
        // registered. Both handlers will see the same event instance
        // so we create a copy to avoid interfering with the dispatching of
        // the mouseover/mouseout event.
        var copiedEvent = jsActionEvent.createMouseSpecialEvent(
            e, /** @type {!Element} */ (element));
        eventInfo['event'] = /** @type {!Event} */ (copiedEvent);
        // Since the mouseenter/mouseleave events do not bubble, the target
        // of the event is technically the node on which the jsaction is
        // specified (the actionElement).
        eventInfo['targetElement'] = element;
      } else {
        eventInfo['action'] = '';
        eventInfo['actionElement'] = null;
      }
    }
    return eventInfo;
  }
  // Reset action-related properties of the current eventInfo, to ensure we
  // won't dispatch a non-existing action.
  eventInfo['action'] = '';
  eventInfo['actionElement'] = null;
  return eventInfo;
};

/**
 * @param {string} eventType
 * @param {!Event} e
 * @param {!Element} targetElement
 * @param {string} action
 * @param {Element} actionElement
 * @param {number=} optTimeStamp
 * @return {./typedefs.EventInfo}
 * @private
 */
EventContract.createEventInfoInternal_ =
  function (eventType, e, targetElement, action, actionElement, optTimeStamp) {
    // Event#timeStamp is broken on Firefox for synthetic events.  See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=238041 for details.  Since
    // Firefox marks Event#timeStamp as read-only, the only workaround is to
    // expose a timestamp directly in eventInfo, to be consistent across all
    // browsers.
    return /** @type {./typedefs.EventInfo} */ ({
      'eventType': eventType,
      'event': e,
      'targetElement': targetElement,
      'action': action,
      'actionElement': actionElement,
      'timeStamp': optTimeStamp || Date.now()
    });
  };

/**
 * Accesses the event handler attribute value of a DOM node. It guards
 * against weird situations (described in the body) that occur in
 * connection with nodes that are removed from their document.
 * @param {!Element} node The DOM node.
 * @param {string} attribute The name of the attribute to access.
 * @return {?string} The attribute value if it was found, null
 *     otherwise.
 * @private
 */
EventContract.getAttr_ = function (node, attribute) {
  var value = null;
  // NOTE(user): Nodes in IE do not always have a getAttribute
  // method defined. This is the case where sourceElement has in
  // fact been removed from the DOM before eventContract begins
  // handling - where a parentNode does not have getAttribute
  // defined.
  // NOTE(user): We must use the 'in' operator instead of the regular dot
  // notation, since the latter fails in IE8 if the getAttribute method is not
  // defined. See b/7139109.
  if ('getAttribute' in node) {
    value = node.getAttribute(attribute);
  }
  return value;
};

/**
 * Accesses the jsaction map on a node and retrieves the name of the
 * action the given event is mapped to, if any. It parses the
 * attribute value and stores it in a property on the node for
 * subsequent retrieval without re-parsing and re-accessing the
 * attribute. In order to fully qualify jsaction names using a
 * namespace, the DOM is searched starting at the current node and
 * going through ancestor nodes until a jsnamespace attribute is
 * found.
 *
 * @param {!Element} node The DOM node to retrieve the jsaction map
 *     from.
 * @param {string} eventType The type of the event for which to
 *     retrieve the action.
 * @param {!Event} event The current browser event.
 * @param {!Node} container The node which limits the namespace lookup
 *     for a jsaction name. The container node itself will not be
 *     searched.
 * @return {./typedefs.ActionInfo} The action info.
 * @private
 */
EventContract.getAction_ = function (node, eventType, event,
    container) {
  var actionMap = Cache.get(node);
  if (!actionMap) {
    actionMap = {};
    Cache.set(node, actionMap);
    var attvalue = EventContract.getAttr_(node, Attribute.JSACTION);
    if (attvalue) {
      var values = attvalue.split(EventContract.REGEXP_SEMICOLON_);
      for (var i = 0, I = values ? values.length : 0; i < I; i++) {
        var value = values[i];
        if (!value) {
          continue;
        }
        var colon = value.indexOf(Char.EVENT_ACTION_SEPARATOR);
        var hasColon = colon != -1;
        var type = hasColon ?
            EventContract.stringTrim_(value.substr(0, colon)) :
            EventContract.defaultEventType_;
        var action = EventContract.getQualifiedName_(
            hasColon ? EventContract.stringTrim_(
                value.substr(colon + 1)) : value,
            node, container);

        actionMap[type] = action;
      }
    }
  }

  if (EventContract.A11Y_CLICK_SUPPORT) {
    if (eventType == EventContract.CLICKKEY_) {
      // A 'click' triggered by a DOM keypress should be mapped to the 'click'
      // jsaction.
      eventType = EventType.CLICK;
    } else if (eventType == EventType.CLICK &&
        !actionMap[EventType.CLICK]) {
      // A 'click' triggered by a DOM click should be mapped to the 'click'
      // jsaction, if available, or else fallback to the 'clickonly' jsaction.
      // If 'click' and 'clickonly' jsactions are used together, 'click' will
      // prevail.
      eventType = EventType.CLICKONLY;
    }
  }

  if (EventContract.FAST_CLICK_SUPPORT &&
      // Don't want fast click behavior? Just bind clickonly instead.
      actionMap[EventType.CLICK]) {
    var fastType = EventContract.getFastClickEventType_(node,
        eventType, event, actionMap);
    if (!fastType) {
      // Null means to stop looking for further events, as the logic event
      // has already been handled or the event started a sequence that may
      // eventually lead to a logic click event.
      return {
        eventType: eventType,
        action: '',
        ignore: true
      };
    } else {
      eventType = fastType;
    }
  }

  // An empty action indicates that no jsaction attribute was found in the given
  // DOM node.
  var actionName = actionMap[eventType] || '';

  return {
    eventType: eventType,
    action: actionName,
    ignore: false
  };
};

/**
 * Returns the qualified jsaction name, i.e. the name of the jsaction
 * including the namespace part before the dot. If the given jsaction
 * name doesn't already contain the namespace, the function iterates
 * over ancestor nodes until a jsnamespace attribute is found, and
 * uses the value of that attribute as the namespace.
 *
 * @param {string} name The jsaction name to resolve the namespace of.
 * @param {Element} start The node from which to start searching for a
 *     jsnamespace attribute.
 * @param {Node} container The node which limits the search for a
 *     jsnamespace attribute. This node will be searched.
 * @return {string} The qualified name of the jsaction. If no
 *     namespace is found, returns the unqualified name in case it
 *     exists in the global namespace.
 * @private
 */
EventContract.getQualifiedName_ = function (name, start, container) {
  if (EventContract.JSNAMESPACE_SUPPORT) {
    if (EventContract.isQualifiedName_(name)) {
      return name;
    }

    for (var node = start; node; node = node.parentNode) {
      var ns = EventContract.getNamespace_(
          /** @type {!Element} */(node));
      if (ns) {
        return ns + Char.NAMESPACE_ACTION_SEPARATOR + name;
      }

      // If this node is the container, stop.
      if (node == container) {
        break;
      }
    }
  }

  return name;
};

/**
 * Converts a sequence of touchstart and touchend events into a click event
 * and will then ignore a subsequent click event (within 400ms).
 * @param {!Element} node The current node with a jsaction annotation.
 * @param {string} eventType
 * @param {!Event} event The current browser event.
 * @param {!Object.<string, string>} actionMap
 * @return {?string} The mapped event type or null if the event should be
 *     ignored.
 * @private
 */
EventContract.getFastClickEventType_ = function (node, eventType, event,
    actionMap) {
  // TODO(user): Disable fast click emulation for browsers that don't need
  // it (Currently Chrome 32 and IE10 with layer.style.msTouchAction == 'none').
  var fastClickNode = EventContract.fastClickNode_;
  // A click event is being emitted onto what was previously the target of
  // a fast click: Ignore this click.
  if (eventType == EventType.CLICK) {
    for (var i = 0; i < EventContract.fastClickedNodes_.length; ++i) {
      if (EventContract.fastClickedNodes_[i] == node) {
        EventContract.fastClickedNodes_.splice(i, 1);
        return null;
      }
    }
    return eventType;
  }

  if (event.targetTouches && event.targetTouches.length > 1) {
    // Click emulation does not make sense for multi touch.
    return eventType;
  }
  var target = /** @type {!Element} */jsActionEvent.getTarget(event);
  if (target) {
    // Don't do anything special for clicks on elements with elaborate built in
    // click and focus behavior.
    var type = (target.type || target.tagName || '').toUpperCase();
    if (type == 'TEXTAREA' || type == 'TEXT' || type == 'PASSWORD' ||
        type == 'SEARCH') {
      return eventType;
    }
  }

  // When a touchstart is fired, remember the action node in a global variable.
  // When a subsequent touchend arrives, it'll be interpreted as a click.
  if (eventType == EventType.TOUCHSTART &&
      // If the jsaction binds touchstart or touchend explicitly, we don't do
      // anything special with it
      !actionMap[EventType.TOUCHSTART] &&
      !actionMap[EventType.TOUCHEND]) {
    EventContract.fastClickNode_ = node;
    clearTimeout(EventContract.fastClickTimeout_);

    // If touchend doesn't arrive within a reasonable amount of time, this is
    // a long click and not a click, so we throw the state away and will ignore
    // a later touchend.
    EventContract.fastClickTimeout_ = setTimeout(
        EventContract.resetFastClickNode_, 400);
    return null;
  } else if (eventType == EventType.TOUCHEND && fastClickNode == node) {
    // If a touchend was fired on what had a previous touchstart,
    // count the event as a click.
    EventContract.patchTouchEventToBeClickLike_(event);
    eventType = EventType.CLICK;
    EventContract.fastClickedNodes_.push(node);
  } else if (eventType == EventType.TOUCHMOVE && fastClickNode) {
    // Touchmove is fired when the user scrolls. In this case a previous
    // touchstart is ignored.
    EventContract.resetFastClickNode_();
  }
  return eventType;
};

/**
 * Cancels the expectation that there might come a touchend to after a
 * touchstart, so we can synthesize a click.
 * @private
 */
EventContract.resetFastClickNode_ = function () {
  EventContract.fastClickNode_ = null;
};

/**
 * To be called after it was decided that a click event should be synthesized
 * from a touchend event.
 * Takes a touch event, adds common fields found in mouse events and changes the
 * type to 'click', so that the resulting event looks more like a real click
 * event.
 * @param {!Event} event A touch event.
 * @private
 */
EventContract.patchTouchEventToBeClickLike_ = function (event) {
  // jscs:disable requireDotNotation
  event['originalEventType'] = event.type;
  // jscs:enable requireDotNotation

  event.type = EventType.CLICK;
  var touch = (event.changedTouches && event.changedTouches[0]) ||
      (event.touches && event.touches[0]);
  if (touch) {
    event.clientX = touch.clientX;
    event.clientY = touch.clientY;
    event.screenX = touch.screenX;
    event.screenY = touch.screenY;
    event.pageX = touch.pageX;
    event.pageY = touch.pageY;
  }
};

if (EventContract.JSNAMESPACE_SUPPORT) {
  /**
   * Checks if a jsaction name contains a namespace part.
   * @param {string} name The name of a jsaction.
   * @return {boolean} Whether the name contains a namespace part.
   * @private
   */
  EventContract.isQualifiedName_ = function (name) {
    return name.indexOf(Char.NAMESPACE_ACTION_SEPARATOR) >= 0;
  };

  /**
   * Returns the value of the jsnamespace attribute of the given node.
   * Also caches the value for subsequent lookups.
   * @param {!Element} node The node whose jsnamespace attribute is being
   *     asked for.
   * @return {?string} The value of the jsnamespace attribute, or null if not
   *     found.
   * @private
   */
  EventContract.getNamespace_ = function (node) {
    var jsnamespace = Cache.getNamespace(node);
    // Only query for the attribute if it has not been queried for
    // before. EventContract.getAttr_() returns null if an
    // attribute is not present. Thus, jsnamespace is string|null if
    // the query took place in the past, or undefined if the query did
    // not take place.
    if (jsnamespace === undefined) {
      jsnamespace =
          EventContract.getAttr_(node, Attribute.JSNAMESPACE);
      Cache.setNamespace(node, jsnamespace);
    }
    return jsnamespace;
  };
}

/**
 * Factory for container installer functions. The returned function
 * will install the given handler for the event given by name here on
 * the container passed to the returned function. It is used to
 * register all currently known events on a newly registered
 * container.
 *
 * @param {string} name The name of the event.
 * @param {./typedefs.EventHandlerFunction} handler An event handler.
 * @return {./typedefs.ContainerInitializerFunction} A function that, when
 *     applied to an Element, installs the given event handler for the
 *     event type given by name.
 * @private
 */
EventContract.containerHandlerInstaller_ = function (name, handler) {
  /**
   * @param {!Element} div The container to install this handler on.
   * @return {./typedefs.EventHandlerInfo} The event name and the
   *    handler installed by the function.
   */
  var handlerInstaller = function (div) {
    return jsActionEvent.addEventListener(div, name, handler);
  };
  return handlerInstaller;
};

/**
 * Enables jsaction handlers to be called for the event type given by
 * name.
 *
 * If the event is already registered, this does nothing.
 *
 * @param {string} name Event name.
 */
EventContract.prototype.addEvent = function (name) {
  if (this.events_.hasOwnProperty(name)) {
    return;
  }

  if (!EventContract.MOUSE_SPECIAL_SUPPORT &&
      (name == EventType.MOUSEENTER ||
       name == EventType.MOUSELEAVE)) {
    return;
  }

  var handler = EventContract.eventHandler_(this, name);

  // Install the callback which handles events on the container.
  var installer = EventContract.containerHandlerInstaller_(
      name, handler);

  // Store the callback to allow us to replay events.
  this.events_[name] = handler;

  this.installers_.push(installer);
  for (var i = 0; i < this.containers_.length; ++i) {
    this.containers_[i].installHandler(installer);
  }

  // Automatically install a keypress/keydown event handler if support for
  // accessible clicks is turned on.
  if (EventContract.A11Y_CLICK_SUPPORT &&
      name == EventType.CLICK) {
    this.addEvent(EventType.KEYDOWN);
  }

  if (EventContract.FAST_CLICK_SUPPORT &&
      name == EventType.CLICK) {
    this.addEvent(EventType.TOUCHSTART);
    this.addEvent(EventType.TOUCHEND);
    this.addEvent(EventType.TOUCHMOVE);
  }
};

/**
 * Returns the event handler function for a given event type.
 * @param {string} name Event name.
 * @return {./typedefs.EventHandlerFunction|undefined} The event handler
 *     function or undefined if it does not exist.
 */
EventContract.prototype.handler = function (name) {
  return this.events_[name];
};

/**
 * Signs the event contract for a new container. All registered events
 * are enabled for this container too. Containers have to be kept disjoint,
 * so if the newly added container is a parent/child of existing containers,
 * they will be merged.
 *
 * The caller of addContainer can keep a reference to this if it desires
 * to remove the container later.
 *
 * @param {!Element} div The container element. Usually a DIV, but not
 *     constrained to.
 * @return {!EventContractContainer} The container object that was
 *     created.
 */
EventContract.prototype.addContainer = function (div) {
  var container = new EventContractContainer(div);
  if (!EventContract.STOP_PROPAGATION) {
    if (this.hasContainerFor_(div)) {
      // This container has an ancestor that is already a contract container.
      // Don't install event listeners on it when STOP_PROPAGATION is false
      // in order to prevent an event from being handled multiple times. We
      // still want to keep track of it in order to be able to correctly
      // add/remove containers.
      this.nestedContainers_.push(container);
      return container;
    }
    this.setUpContainer_(container);
    this.containers_.push(container);
    this.updateNestedContainers_();
  } else {
    this.setUpContainer_(container);
    this.containers_.push(container);
  }

  return container;
};

/**
 * Updates the list of nested containers after an add/remove operation. Only
 * containers that are not children of other containers are placed in the
 * containers list (and have event listeners on them). This is done in order to
 * prevent events from being handled multiple times when STOP_PROPAGATION is
 * false.
 * @private
 */
EventContract.prototype.updateNestedContainers_ = function () {
  var allContainers = this.nestedContainers_.concat(this.containers_);
  var newNestedContainers = [];
  var newContainers = [];
  var container;

  for (var i = 0; i < this.containers_.length; ++i) {
    container = this.containers_[i];
    if (EventContractContainer.isNested_(container, allContainers)) {
      newNestedContainers.push(container);
      // Remove the event listeners from the nested container.
      container.cleanUp();
    } else {
      newContainers.push(container);
    }
  }

  for (var j = 0; j < this.nestedContainers_.length; ++j) {
    container = this.nestedContainers_[j];
    if (EventContractContainer.isNested_(container, allContainers)) {
      newNestedContainers.push(container);
    } else {
      newContainers.push(container);
      // The container is no longer nested, add event listeners on it.
      this.setUpContainer_(container);
    }
  }

  this.containers_ = newContainers;
  this.nestedContainers_ = newNestedContainers;
};

/**
 * Adds the event listeners on the new container.
 * @param {!EventContractContainer} container The newly added
 *     container.
 * @private
 */
EventContract.prototype.setUpContainer_ = function (container) {
  var div = container.div;

  // In iOS, event bubbling doesn't happen automatically in any DOM element,
  // unless it has an onclick attribute or DOM event handler attached to it.
  // This breaks JsAction in some cases. See "Making Elements Clickable" section
  // at http://goo.gl/2VoGnB.
  //
  // A workaround for this issue is to change the CSS cursor style to 'pointer'
  // for the container element, which magically turns on event bubbling. This
  // solution is described in the comments section at http://goo.gl/6pEO1z.
  //
  // We use a navigator.userAgent check here as this problem is present both on
  // Mobile Safari and thin WebKit wrappers, such as Chrome for iOS.
  if (EventContract.isIos_) {
    div.style.cursor = 'pointer';
  }

  for (var i = 0; i < this.installers_.length; ++i) {
    container.installHandler(this.installers_[i]);
  }
};

/**
 * Tests whether this EventContract already has a container that is a parent of
 * the div sent as a parameter.
 * @param {Element} div The element for which we need to test if there already
 *     is a container for it.
 * @return {boolean} True if there already is such a registered container,
 *     false otherwise.
 * @private
 */
EventContract.prototype.hasContainerFor_ = function (div) {
  for (var i = 0; i < this.containers_.length; i++) {
    if (this.containers_[i].containsNode(div)) {
      return true;
    }
  }
  return false;
};

/**
 * Removes an already-added container from the contract.
 *
 * @param {EventContractContainer} container The container object to
 *     remove.
 */
EventContract.prototype.removeContainer = function (container) {
  container.cleanUp();
  var removed = false;
  for (var i = 0; i < this.containers_.length; ++i) {
    if (this.containers_[i] === container) {
      this.containers_.splice(i, 1);
      removed = true;
      break;
    }
  }

  if (!removed) {
    for (var j = 0; j < this.nestedContainers_.length; ++j) {
      if (this.nestedContainers_[j] === container) {
        this.nestedContainers_.splice(j, 1);
        break;
      }
    }
  }

  if (!EventContract.STOP_PROPAGATION) {
    this.updateNestedContainers_();
  }
};

// jscs:disable maximumLineLength
/**
 * Register a dispatcher function. Event info of each event mapped to
 * a jsaction is passed for handling to this callback. The queued
 * events are passed as well to the dispatcher for later replaying
 * once the dispatcher is registered. Clears the event queue to null.
 *
 * @param {function((!./typedefs.EventInfo|!Array.<!./typedefs.EventInfo>), boolean=):void} dispatcher The dispatcher function.
 */
EventContract.prototype.dispatchTo = function (dispatcher) {
  this.dispatcher_ = dispatcher;
  if (this.queue_) {
    if (this.queue_.length > 0) {
      // TODO(user): Consider to call dispatcher repeatedly and to
      // pass the fields of event info as separate arguments. This
      // gets rid of the requirement to keep the fields of EventInfo
      // unobfuscated because they are accessed from separate
      // jsbinaries. It would also resolve the issue whether
      // dispatcher may take ownership of the queue object.
      dispatcher(this.queue_);
    }
    this.queue_ = null;
  }
};
// jscs:enable maximumLineLength

module.exports = {
  EventContract: EventContract,
  EventContractContainer: EventContractContainer
};


/***/ },

/***/ 193:
/***/ function(module, exports, __webpack_require__) {

/**
 * @fileoverview Contains the generic interface for iterating over the dom path
 * an event has traveled. These generators are meant to be singletons so you
 * should not construct them yourself. You should use the static factory method
 * getGenerator instead.
 */

'use strict';

var Property = __webpack_require__(4).Property;

/** @interface */
function Generator() {}

// jscs:disable jsDoc
/**
 * @return {Element} The next element in the generator or null if none found.
 */
Generator.prototype.next = function () {};
// jscs:enable jsDoc

/**
 * Constructs a generator of all the ancestors of an element.
 * @constructor
 * @implements {Generator}
 */
function Ancestors() {
  /**
   * @type {Element}
   * @private
   */
  this.node_ = null;

  /**
   * @type {Element}
   * @private
   */
  this.container_ = null;
}

/**
 * Resets an ancestors generator of an element with a new target and container.
 * @param {!Element} target the element to start walking ancestors at.
 * @param {!Element} container the element to stop walking ancestors at.
 * @return {!Generator}
 * @private
 */
Ancestors.prototype.reset_ = function (target, container) {
  this.node_ = target;
  this.container_ = container;
  return this;
};

/** @override */
Ancestors.prototype.next = function () {
  // Walk to the parent node, unless the node has a different owner in
  // which case we walk to the owner.
  var curr = this.node_;
  if (this.node_ && this.node_ != this.container_) {
    this.node_ = this.node_[Property.OWNER] || this.node_.parentNode;
  } else {
    this.node_ = null;
  }

  return curr;
};

/**
 * A reusable generator for dom ancestor walks.
 * @type {!Ancestors}
 * @private
 */
var ancestors_ = new Ancestors();

/**
 * Constructs a generator of all elements in a path array.
 * Correctly handles syntax.Property.OWNER on elements.
 * @constructor
 * @implements {Generator}
 */
function EventPath() {
  /**
   * @type {!Array.<!Element>}
   * @private
   */
  this.path_ = [];

  /**
   * @type {number}
   * @private
   */
  this.idx_ = 0;

  /**
   * @type {Element}
   * @private
   */
  this.container_ = null;

  /**
   * @type {boolean}
   * @private
   */
  this.usingAncestors_ = false;
}

/**
 * Resets an EventPath with a new path and container.
 * @param {!Array.<!Element>} path
 * @param {!Element} container
 * @return {!Generator}
 * @private
 */
EventPath.prototype.reset_ = function (path, container) {
  this.path_ = path;
  this.idx_ = 0;
  this.container_ = container;
  this.usingAncestors_ = false;
  return this;
};

/** @override */
EventPath.prototype.next = function () {
  // TODO(user): If we could ban OWNERS for all users of event.path
  // then you could greatly simplify the code here.
  if (this.usingAncestors_) {
    return ancestors_.next();
  }
  if (this.idx_ != this.path_.length) {
    var curr = this.path_[this.idx_];
    this.idx_++;
    if (curr != this.container_) {
      // NOTE(user): The presence of the OWNER property indicates that
      // the user wants to override the browsers expected event path with
      // one of their own. The eventpath generator still needs to respect
      // the OWNER property since this is used by a lot of jsactions
      // consumers.
      if (curr && curr[Property.OWNER]) {
        this.usingAncestors_ = true;
        ancestors_.reset_(
            curr[Property.OWNER],
            /** @type {!Element} */(this.container_));
      }
    }
    return curr;
  }
  return null;
};

/**
 * A reusable generator for dom ancestor walks.
 * @type {!EventPath}
 * @private
 */
var eventPath_ = new EventPath();

/**
 * Return the correct dom generator for a given event.
 * @param {!Event} e the event.
 * @param {!Element} target the events target element.
 * @param {!Element} container the jsaction container.
 * @return {!Generator}
 */
function getGenerator(e, target, container) {
  return e.path ? eventPath_.reset_(e.path, container) :
                  ancestors_.reset_(target, container);
}

module.exports = {
  getGenerator: getGenerator,
  Ancestors: Ancestors,
  EventPath: EventPath,
  Generator: Generator,
  ancestors_: ancestors_,
  eventPath_: eventPath_
};


/***/ }

/******/ })


/** WEBPACK FOOTER **
 ** jsaction.bundle.8555e21e5bcb532038fa.js
 **/